// Canal por el que se AGENDÓ una demo, como detalle secundario del chip de origen (28/9/2026).
//
// El chip dice de dónde vino el LEAD (v_demos.lead_source, primer toque: «Anuncio Meta»); este
// helper añade por dónde acabó agendando cuando aporta algo: «Anuncio Meta · agendó por
// WhatsApp», «Anuncio Meta · agendó el setter IA». Se calla cuando repetiría lo mismo (un lead
// de WhatsApp que agenda por WhatsApp) o cuando el canal es la propia landing.
//
// Devuelve la clave i18n (misAgendas:leadOrigin.via.*) o null.
const WHATSAPPY = new Set(["whatsapp_inbound", "whatsapp_captacion", "flow_vendedor"]);

export function bookedVia(demo, kind) {
  if (!demo || !kind || demo.origin === "config") return null;
  if (demo.origin_detail === "setter_ia") return "setter";
  if (demo.origin_detail === "whatsapp" || demo.origin === "flow") return WHATSAPPY.has(kind) ? null : "whatsapp";
  if (demo.origin === "manual") return ["manual", "cold_call"].includes(kind) ? null : "manual";
  return null;
}
